import React from 'react';
import './CallToAction.css';

function CallToAction() {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>Ready to Collaborate or Join Us?</h2>
        <p>Whether you're a founder, investor, or innovator — let’s shape the future together.</p>
        <a href="/contact" className="cta-button">Get in Touch</a>
      </div>
    </section>
  );
}

export default CallToAction;
